import dynamic from 'next/dynamic';

const Infographic = {
  getSettings: componentSettings => ({
    ...componentSettings
  }),
  VariantComponent: dynamic(
    () => import(/* webpackChunkName: "blazePbVariantInfographic" */ './Infographic')
  )
};

export default Infographic;
